import BaseWidget from './component'

export default BaseWidget
